import React, {Component} from 'react';
import BackEnd from "../../../backend/BackEnd";
import AddressSelector from "../../../controls/AddressSelector";
import {withRouter} from "react-router";
import MaskedInput from "../../../controls/MaskedInput";
import PlainDropdown from "../../../controls/PlainDropdown";
import ContactMeConfirmationModal from "./modals/ContactMeConfirmationModal";
import {Token, UserContext} from "../../../auth/Auth";
import {registerMetricaEvent} from "../../../utils/metrica";
import ActionLink from "../../../controls/ActionLink";
import AdvertConfirmationModal from "./modals/AdvertConfirmationModal";
import './AdvertWizard.css';
import ImageUploader from "../../../components/ImageUploader";
import Fieldset from "../../../utils/components/Fieldset";
import {required, addressRequired, number, min, validate, phoneNumberRequired, conditional} from "../../../utils/validation";
import Dropdown from "../../../controls/Dropdown";
import PermissionsRequired from "../../../utils/components/PermissionsRequired";

const $ = window.jQuery;

class AdvertWizard extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {
        isLoading: false,
        showContactMeConfirmationModal: false,
        showAdvertConfirmationModal: false,
        comment: '',
        contactMePhoneNumber: '',
        advertTypeId: this.getAdvertTypeId(this.props.match.params.type),
        productCondition: 'Новый',
        productSize: '1200x800',
        productCategoryId: '',
        productCategories: [],
        productId: '',
        productName: '',
        productBuyPrice: '',
        productSellPrice: '',
        filteredProducts: [],
        products: [],
        address: {},
        deliveryTypeId: 1,
        advertDeliveryTypes: [],
        costPerItem: '',
        totalCount: '',
        repeatabilityTypeId: 1,
        repeatabilityTypes: [],
        taxTypeId: 1,
        taxTypes: [],
        files: [],
        imageLimit: 5,
        isNetPalletDeal: false,
        authorId: '',
        fullName: '',
        email: '',
        phoneNumber: '',
        code: '',
        formState: {}
    };
    fieldUpdateHandle = (event => this.setState({[event.target.name]: event.target.value}));
    getProductionSelectorItems = new BackEnd.Products.GetSelectorItems(this);
    getDefinitionsLists = new BackEnd.Adverts.GetDefinitionsLists(this);
    createAdvert = new BackEnd.Adverts.Create(this);
    createLead = new BackEnd.Adverts.CreateLeadFromCallMe(this);
    sendSecurityCode = new BackEnd.Authentication.SendSecurityCode(this);
    signIn = new BackEnd.Authentication.SignIn(this);
    step2AdvertMetadata = {
        address: [addressRequired('Укажите адрес')],
        totalCount: [required('Укажите количество'), number(), min(1, 'Количество не может быть меньше 1')],
        costPerItem: [required('Укажите стоимость'), number(), min(0, 'Стоимость не может быть меньше 0')],

    };
    step2TenderBuyMetadata = {
        address: [addressRequired('Укажите адрес')],
        totalCount: [required('Укажите количество'), number(), min(1, 'Количество не может быть меньше 1')]
    };
    step2TenderSellMetadata = {
        address: [addressRequired('Укажите адрес')],
        totalCount: [required('Укажите количество'), number(), min(500, 'Количество не может быть меньше 500')]
    };
    step3Metadata = {
        fullName: [
            conditional(() => {
                const userContext = UserContext.get();
                return !userContext || !userContext.permissions.find(p => p === 1205);
            }, required('Введите ФИО'))
        ],
        email: [
            conditional(() => {
                const userContext = UserContext.get();
                return !userContext || !userContext.permissions.find(p => p === 1205);
            }, required('Введите EMail'))
        ],
        phoneNumber: [
            conditional(() => {
                const userContext = UserContext.get();
                return !userContext || !userContext.permissions.find(p => p === 1205);
            }, phoneNumberRequired())
        ]
    };

    async componentDidMount() {
        this.$wizard = $(this.wizard);
        this.$wizard.pxWizard();

        const userContext = UserContext.get();

        if (userContext && userContext.userPhoneNumber) {
            const userPhoneNumber = userContext.userPhoneNumber.substr(1, userContext.userPhoneNumber - 1);

            this.setState({
                contactMePhoneNumber: userPhoneNumber,
                phoneNumber: userPhoneNumber
            });
        }

        const products = await this.getProductionSelectorItems.call();
        const definitions = await this.getDefinitionsLists.call();

        this.setState({
            products,
            ...definitions
        }, () => this.setProductCategories());
    }

    async componentWillReceiveProps({match}) {
        this.setState({advertTypeId: this.getAdvertTypeId(match.params.type)});
        this.$wizard.pxWizard('goTo', 0);
    }

    render() {
        const productPrice = this.state.advertTypeId === 1
            ? this.state.productBuyPrice
            : this.state.productSellPrice;

        const userContext = UserContext.get();
        const showLeadForm = !userContext || !userContext.permissions.find(p => p === 1205);

        return (
            <div>
                <div className="page-header">
                    <div className="row">
                        <div className="col-md-4 text-xs-center text-md-left text-nowrap">
                            <h1>Новое объявление</h1>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-12">
                        <div className="panel">
                            <div className="px-block-alerts">
                                <div className="alert alert-info">
                                    <p className="font-scale-125">Я не хочу заполнять форму. Позвоните мне, чтобы обсудить детали:</p>
                                    <div className="row">
                                        <div className="col-lg-4 col-xl-3 col-xxl-2">
                                            <div className="input-group">
                                                <div className="input-group-addon">
                                                    <span className="flag-icon flag-icon-ru"/> +7
                                                </div>
                                                <MaskedInput type="text" className="form-control"
                                                             id="contactMePhoneNumber" name="contactMePhoneNumber"
                                                             mask="(999) 999-9999"
                                                             value={this.state.contactMePhoneNumber}
                                                             onChange={this.fieldUpdateHandle}/>
                                            </div>
                                        </div>
                                        <div className="col-md-5">
                                            <button type="button" className="btn btn-primary"
                                                    disabled={this.state.contactMePhoneNumber.replace(/[^\d]/g, '').length !== 10}
                                                    onClick={() => this.submitContactMe()}>
                                                Свяжитесь со мной
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="panel-body">
                                <form className={`col-md-12 col-lg-12 col-xl-10 ${this.state.isLoading ? 'form-loading' : ''}`}>
                                    <div ref={el => this.wizard = el} className="wizard wizard-bordered m-b-0">
                                        <div className="wizard-wrapper">
                                            <ul className="wizard-steps">
                                                <li data-target="#advert-wizard-step1" className="active">
                                                    <span className="wizard-step-number">1</span>
                                                    <span className="wizard-step-complete">
                                                        <i className="fa fa-check text-success"/>
                                                    </span>
                                                    <span className="wizard-step-caption font-scale-110">
                                                        Шаг 1
                                                        <span className="wizard-step-description">Выбор типа паллет</span>
                                                    </span>
                                                </li>
                                                <li data-target="#advert-wizard-step2">
                                                    <span className="wizard-step-number">2</span>
                                                    <span className="wizard-step-complete">
                                                        <i className="fa fa-check text-success"/>
                                                    </span>
                                                    <span className="wizard-step-caption font-scale-110">
                                                        Шаг 2
                                                        <span className="wizard-step-description">Данные заказа</span>
                                                    </span>
                                                </li>
                                                <li data-target="#advert-wizard-step3">
                                                    <span className="wizard-step-number">3</span>
                                                    <span className="wizard-step-complete">
                                                        <i className="fa fa-check text-success"/>
                                                    </span>
                                                    <span className="wizard-step-caption font-scale-110">
                                                        Шаг 3
                                                        <span className="wizard-step-description">Контакты</span>
                                                    </span>
                                                </li>
                                                <li data-target="#advert-wizard-step4">
                                                    <span className="wizard-step-number">4</span>
                                                    <span className="wizard-step-complete">
                                                        <i className="fa fa-check text-success"/>
                                                    </span>
                                                    <span className="wizard-step-caption font-scale-110">
                                                        Завершение
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="wizard-content">
                                            <div className="wizard-pane active" id="advert-wizard-step1">
                                                {
                                                    this.state.advertTypeId === 1
                                                        ? (
                                                            <p>
                                                                Для формирования заказа укажите основные характеристики паллет, которые{' '}
                                                                вы хотите продать, для того, чтобы мы подобрали оптимальный тип поддона:
                                                            </p>
                                                        )
                                                        : (
                                                            <p>
                                                                Для формирования заказа укажите основные характеристики паллет, которые{' '}
                                                                вы ищете, для того, чтобы мы подобрали оптимальный тип поддона:
                                                            </p>
                                                        )
                                                }
                                                <div className="row">
                                                    <div className="col-sm-12">
                                                        <div className="btn-group valign-middle m-r-2 m-b-2" data-toggle="buttons">
                                                            <button type="button"
                                                                    className={`btn btn-primary ${this.getClassName(this.state.productCondition, 'Новый')}`}
                                                                    onClick={() => this.updateProduct({productCondition: 'Новый'})}>
                                                                {this.getIcon(this.state.productCondition, 'Новый')} Новый
                                                            </button>
                                                            <button type="button"
                                                                    className={`btn btn-primary ${this.getClassName(this.state.productCondition, 'Б/У')}`}
                                                                    onClick={() => this.updateProduct({productCondition: 'Б/У'})}>
                                                                {this.getIcon(this.state.productCondition, 'Б/У')} Б/У
                                                            </button>
                                                        </div>
                                                        <div className="btn-group valign-middle m-r-2 m-b-2" data-toggle="buttons">
                                                            <button type="button"
                                                                    className={`btn btn-primary ${this.getClassName(this.state.productSize, '1200x800')}`}
                                                                    onClick={() => this.updateProduct({productSize: '1200x800'})}>
                                                                {this.getIcon(this.state.productSize, '1200x800')} 1200x800
                                                            </button>
                                                            <button type="button"
                                                                    className={`btn btn-primary ${this.getClassName(this.state.productSize, '1200x1000')}`}
                                                                    onClick={() => this.updateProduct({productSize: '1200x1000'})}>
                                                                {this.getIcon(this.state.productSize, '1200x1000')} 1200x1000
                                                            </button>
                                                            {
                                                                this.state.productCondition === 'Новый' &&
                                                                <button type="button"
                                                                        className={`btn btn-primary ${this.getClassName(this.state.productSize, '1200x1600')}`}
                                                                        onClick={() => this.updateProduct({productSize: '1200x1600'})}>
                                                                    {this.getIcon(this.state.productSize, '1200x1600')} 1200x1600
                                                                </button>
                                                            }
                                                            {
                                                                this.state.productCondition === 'Новый' &&
                                                                <button type="button"
                                                                        className={`btn btn-primary ${this.getClassName(this.state.productSize, '1200x1900')}`}
                                                                        onClick={() => this.updateProduct({productSize: '1200x1900'})}>
                                                                    {this.getIcon(this.state.productSize, '1200x1900')} 1200x1900
                                                                </button>
                                                            }
                                                            {
                                                                this.state.productCondition === 'Б/У' &&
                                                                <button type="button"
                                                                        className={`btn btn-primary ${this.getClassName(this.state.productSize, '1200x1200')}`}
                                                                        onClick={() => this.updateProduct({productSize: '1200x1200'})}>
                                                                    {this.getIcon(this.state.productSize, '1200x1200')} 1200x1200
                                                                </button>
                                                            }
                                                            {
                                                                this.state.productCondition === 'Б/У' &&
                                                                <button type="button"
                                                                        className={`btn btn-primary ${this.getClassName(this.state.productSize, 'Неотсортированные')}`}
                                                                        onClick={() => this.updateProduct({productSize: 'Неотсортированные'})}>
                                                                    {this.getIcon(this.state.productSize, 'Неотсортированные')} Неотсортированные
                                                                </button>
                                                            }
                                                        </div>
                                                        <PlainDropdown className="form-control valign-middle m-b-2"
                                                                       style={{display: 'inline-block', width: '300px'}}
                                                                       items={this.state.productCategories}
                                                                       value={this.state.productCategoryId}
                                                                       onChange={event => this.updateProductCategory({productCategoryId: event.target.value})}/>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-12 col-md-12 col-lg-10 col-xl-8 col-xxl-6">
                                                        <div className="form-group">
                                                            <label htmlFor="totalCount">Рекомендованный тип паллет</label>
                                                            <PlainDropdown className="form-control"
                                                                           name="productId" id="productId"
                                                                           items={this.state.filteredProducts}
                                                                           value={this.state.productId}
                                                                           onChange={event => this.updateProductId(event.target.value)}/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-12 col-md-12 col-lg-10 col-xl-8 col-xxl-6">
                                                        <div className="form-group">
                                                            <label htmlFor="comment">Комментарий</label>
                                                            <textarea className="form-control" rows="3" style={{ resize: "none" }}
                                                                name="comment" id="comment"
                                                                value={this.state.comment}
                                                                onChange={this.fieldUpdateHandle}
                                                            />
                                                        </div>
                                                    </div>
												</div>
                                                <div className="row">
                                                    <div className="col-sm-12 col-md-12">
                                                        <div className="form-group pull-right">
                                                            <button type="button" className="btn btn-primary" data-wizard-action="next"
                                                                disabled={!this.state.productId}>
                                                                Продолжить
                                                            </button>
                                                        </div>
                                                    </div>
												</div>
                                            </div>
                                            <div className="wizard-pane" id="advert-wizard-step2">
                                                <fieldset className="form-group">
                                                    <label>Тип паллет</label>
                                                    <div>
                                                        {this.state.productName}
                                                        {' '}
                                                        <small>(<ActionLink data-wizard-action="prev">изменить тип</ActionLink>)</small>
                                                    </div>
                                                </fieldset>
                                                <div className="row m-b-2">
                                                    <div className="col-xl-4">
                                                        <fieldset className="form-group m-b-0">
                                                            <label htmlFor="totalCount">Тип доставки</label>
                                                            <PlainDropdown className="form-control"
                                                                           name="deliveryTypeId" id="deliveryTypeId"
                                                                           items={this.state.advertDeliveryTypes}
                                                                           value={this.state.deliveryTypeId}
                                                                           onChange={this.fieldUpdateHandle}/>
                                                        </fieldset>
                                                    </div>
                                                    <div className="col-xl-4">
                                                        <Fieldset formState={this.state.formState} fieldName="address" className="m-b-0">
                                                            <label htmlFor="totalCount">Адрес</label>
                                                            <AddressSelector className="form-control" name="address" id="address"
                                                                             addressholder="Адрес доставки или самовывоза"
                                                                             precision="address"
                                                                             value={this.state.address}
                                                                             onChange={address => this.setState({address: address})}/>
                                                        </Fieldset>
                                                    </div>
                                                </div>
                                                <div className="row m-b-2">
                                                    <div className="col-xl-4">
                                                        <fieldset className="form-group m-b-0">
                                                            <label htmlFor="repeatabilityTypeId">
                                                                {
                                                                    this.state.advertTypeId === 1
                                                                        ? 'Возможность поставлять'
                                                                        : 'Потребность'
                                                                }
                                                            </label>
                                                            <PlainDropdown className="form-control"
                                                                           id="repeatabilityTypeId" name="repeatabilityTypeId"
                                                                           items={this.state.repeatabilityTypes}
                                                                           value={this.state.repeatabilityTypeId}
                                                                           onChange={this.fieldUpdateHandle}/>
                                                        </fieldset>
                                                    </div>
                                                    <div className="col-xl-4">
                                                        <Fieldset formState={this.state.formState} fieldName="totalCount" className="m-b-0">
                                                            <label htmlFor="totalCount">Количество</label>
                                                            <div className="input-group">
                                                                <input type="number" className="form-control"
                                                                       name="totalCount" id="totalCount"
                                                                       min="0"
                                                                       value={this.state.totalCount}
                                                                       onChange={this.fieldUpdateHandle}/>
                                                                <span className="input-group-addon">шт.</span>
                                                            </div>
                                                        </Fieldset>
                                                    </div>
                                                </div>
                                                <div className="row m-b-2">
                                                    <div className="col-xl-4">
                                                        <fieldset className="form-group m-b-0">
                                                            <label htmlFor="account-name">Тип оплаты</label>
                                                            <select className="form-control" name="taxTypeId" id="taxTypeId"
                                                                    value={this.state.taxTypeId}
                                                                    onChange={this.fieldUpdateHandle}>
                                                                {this.state.taxTypes.map(taxType =>
                                                                    <option key={taxType.id}
                                                                            value={taxType.id}>{taxType.text}</option>
                                                                )}
                                                            </select>
                                                        </fieldset>
                                                    </div>
                                                </div>
                                                <div className="row m-b-2">
                                                    <div className="col-md-12">
                                                        <fieldset className="form-group m-b-0">
                                                            <label className="m-b-0">Фотографии</label>
                                                            <ImageUploader imageLimit={5}
                                                                           onChange={files => this.setState({
                                                                               files,
                                                                               imageLimit: 5 - files.length
                                                                           })}/>
                                                            <small className="text-muted">Вы можете прикрепить
                                                                ещё <strong>{this.state.imageLimit}</strong> фотографий
                                                            </small>
                                                        </fieldset>
                                                    </div>
                                                </div>
                                                <div className="row m-b-2">
                                                    <div className="col-xl-3">
                                                        <Fieldset formState={this.state.formState} fieldName="costPerItem"
                                                                  className="m-b-0">
                                                            <label htmlFor="costPerItem">Укажите вашу стоимость</label>
                                                            <div className="input-group">
                                                                <input type="number" className="form-control"
                                                                       name="costPerItem" id="costPerItem"
                                                                       min="0"
                                                                       value={this.state.costPerItem}
                                                                       onChange={this.fieldUpdateHandle}/>
                                                                <span className="input-group-addon">р./шт.</span>
                                                            </div>
                                                        </Fieldset>
                                                    </div>
                                                    {
                                                        productPrice !== 0 &&
                                                        <div className="col-xl-1 font-size-14 text-center" style={{lineHeight: '57px'}}>
                                                            ИЛИ
                                                        </div>
                                                    }
                                                    {
                                                        productPrice !== 0 &&
                                                        <div className="col-xl-8">
                                                            <p>
                                                                {
                                                                    this.state.advertTypeId === 1
                                                                        ? 'Продайте NetPallet по фиксированной цене:'
                                                                        : 'Купите у NetPallet по фиксированной цене:'
                                                                }
                                                                {' '}
                                                                <span
                                                                    className="label label-success label-pill font-size-14">{productPrice} руб.</span>
                                                                <br/>
                                                                {
                                                                    this.state.advertTypeId === 2 &&
                                                                    'Гарантируем качество, выполним поставку в срок'
                                                                }
                                                            </p>
                                                            <button type="button" className="btn btn-primary"
                                                                    onClick={() => {
                                                                        const formMetadata = this.state.advertTypeId === 1
                                                                            ? this.step2TenderSellMetadata
                                                                            : this.step2TenderBuyMetadata;
                                                                        const {isValid, ...formState} = validate(this.state, formMetadata);
                                                                        if (!isValid)
                                                                            return this.setState({formState});

                                                                        this.setState({isNetPalletDeal: true});
                                                                        this.$wizard.pxWizard('goNext');
                                                                    }}>
                                                                {
                                                                    this.state.advertTypeId === 1
                                                                        ? 'Продать сейчас'
                                                                        : 'Купить сейчас'
                                                                }
                                                            </button>
                                                        </div>
                                                    }
                                                </div>
                                                <div className="pull-right">
                                                    <button type="button" className="btn" data-wizard-action="prev">
                                                        Назад
                                                    </button>
                                                    <button type="button" className="btn btn-primary"
                                                            onClick={() => {
                                                                const {isValid, ...formState} = validate(this.state, this.step2AdvertMetadata);
                                                                if (!isValid)
                                                                    return this.setState({formState});

                                                                this.setState({isNetPalletDeal: false});
                                                                this.$wizard.pxWizard('goNext');
                                                            }}>
                                                        Продолжить
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="wizard-pane" id="advert-wizard-step3">
                                                <div className="row">
                                                    <div className="col-sm-12 col-md-12 col-lg-10 col-xl-8 col-xxl-8">
                                                        <p>
                                                            {
                                                                this.state.isNetPalletDeal
                                                                    ? 'Укажите Ваши контактные данные, менеджер NetPallet свяжется с Вами в ближайшее время'
                                                                    : 'Для формирования заказа осталось ввести ваши контактные данные для связи'
                                                            }
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-12 col-md-12 col-lg-10 col-xl-6 col-xxl-4 m-b-2">
                                                        {
                                                            showLeadForm
                                                                ? (
                                                                    <div>
                                                                        <Fieldset formState={this.state.formState} fieldName="fullName">
                                                                            <label className="control-label required"
                                                                                   htmlFor="fullName">ФИО</label>
                                                                            <input type="text" className="form-control"
                                                                                   name="fullName" id="fullName"
                                                                                   value={this.state.fullName}
                                                                                   onChange={this.fieldUpdateHandle}/>
                                                                        </Fieldset>
                                                                        <Fieldset formState={this.state.formState} fieldName="email">
                                                                            <label className="control-label required"
                                                                                   htmlFor="email">EMail</label>
                                                                            <input type="email" className="form-control"
                                                                                   name="email" id="email"
                                                                                   value={this.state.email}
                                                                                   onChange={this.fieldUpdateHandle}/>
                                                                        </Fieldset>
                                                                        <Fieldset formState={this.state.formState} fieldName="phoneNumber">
                                                                            <label className="control-label required"
                                                                                   htmlFor="phoneNumber">Телефон</label>
                                                                            <div className="input-group">
                                                                                <div className="input-group-addon">
                                                                                    <span className="flag-icon flag-icon-ru"/> +7
                                                                                </div>
                                                                                <MaskedInput type="text" className="form-control"
                                                                                             name="phoneNumber" id="phoneNumber"
                                                                                             mask="(999) 999-9999"
                                                                                             value={this.state.phoneNumber}
                                                                                             onChange={this.fieldUpdateHandle}/>
                                                                            </div>
                                                                        </Fieldset>
                                                                    </div>
                                                                )
                                                                : (
                                                                    <fieldset className="form-group">
                                                                        <label className="control-label"
                                                                               htmlFor="fullName">Автор объявления</label>
                                                                        <Dropdown dataSource={new BackEnd.Adverts.SearchAuthors()}
                                                                                  placeholder="Выберите пользователя"
                                                                                  className="form-control"
                                                                                  id="authorId" name="authorId"
                                                                                  value={this.state.authorId}
                                                                                  onChange={this.fieldUpdateHandle}/>
                                                                    </fieldset>
                                                                )
                                                        }
                                                    </div>
                                                </div>
                                                <div className="pull-right">
                                                    <button type="button" className="btn" data-wizard-action="prev">
                                                        Назад
                                                    </button>
                                                    <button type="button" className="btn btn-primary"
                                                            onClick={() => {
                                                                const {isValid, ...formState} = validate(this.state, this.step3Metadata);
                                                                if (!isValid)
                                                                    return this.setState({formState});

                                                                this.signInOrCreateAdvert();
                                                            }}>
                                                        Завершить оформление заказа
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="wizard-pane" id="advert-wizard-step4">
                                                <div className="row">
                                                    <div className="col-sm-12 col-md-10 col-lg-8 col-xl-6 col-xxl-4 m-b-2">
                                                        <p>
                                                            Для подтверждения телефона, указанного при регистрации, на Ваш номер был{' '}
                                                            отправлен 4-значный код, который нужно ввести в поле ниже:
                                                        </p>
                                                        <div className="row text-center m-b-2">
                                                            <div className="col-md-4 col-md-offset-2">
                                                                <fieldset className="form-group m-b-0">
                                                                    <MaskedInput type="text" className="form-control text-center"
                                                                                 id="code" name="code"
                                                                                 mask="9 9 9 9"
                                                                                 value={this.state.code}
                                                                                 onChange={this.fieldUpdateHandle}/>
                                                                </fieldset>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <button type="button" className="btn btn-primary"
                                                                        disabled={this.state.code.replace(/[^\d]/g, '').length !== 4}
                                                                        onClick={() => this.submitCode()}>
                                                                    Подтвердить
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="row text-center">
                                                            <div className="col-sm-12">
                                                                <ActionLink data-wizard-action="prev">
                                                                    Вернуться для изменения номера телефона
                                                                </ActionLink>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <ContactMeConfirmationModal show={this.state.showContactMeConfirmationModal}
                                            onHide={() => this.setState({showContactMeConfirmationModal: false})}/>
                <AdvertConfirmationModal show={this.state.showAdvertConfirmationModal}
                                         onHide={() => this.setState({showAdvertConfirmationModal: false})}>
                    {
                        this.state.isNetPalletDeal
                            ? (
                                <div>
                                    <p>
                                        Мы приняли Ваш заказ и в ближайшее время с Вами свяжется специалист NetPallet для того, чтобы{' '}
                                        запланировать поставку.
                                    </p>
                                    <p>
                                        Не хотите ждать? Вы всегда можете связаться с нами:
                                    </p>
                                    <p className="text-left p-l-1">
                                        Горячая линия <a href="tel:84996475062">8 (499) 647-50-62</a>
                                        <br/>
                                        Служба поддержки <a href="mailto:sales@rcc-rus.ru">info@netpal.ru</a>
                                    </p>
                                </div>
                            ) : (
                                <div>
                                    <p>
                                        Ваше объявление о {this.state.advertTypeId === 1 ? 'продаже' : 'покупке'} паллет проходит{' '}
                                        модерацию и в течение суток будет опубликовано.
                                    </p>
                                    <p>
                                        Мы напишем Вам на почту и по СМС, когда это произойдёт.
                                    </p>
                                    <p>
                                        Не забудьте сохранить ссылку на страницу объявлений:
                                        <br/>
                                        <a href="https://app.netpallet.ru">https://app.netpallet.ru</a>
                                    </p>
                                </div>
                            )
                    }
                </AdvertConfirmationModal>
            </div>
        );
    }

    getAdvertTypeId(type) {
        switch (type) {
            case 'sell':
                return 1;
            case 'buy':
                return 2;
            default:
                this.props.history.push('/adverts')
        }
    }

    async submitContactMe() {
        const result = await this.createLead.call({
            phoneNumber: `7 ${this.state.contactMePhoneNumber}`
        });

        if (result.success) {
            this.setState({showContactMeConfirmationModal: true});
        }
    }

    getClassName(current, expected) {
        return current === expected ? '' : 'btn-outline';
    }

    getIcon(current, expected) {
        return <i className={`fa fa-${current === expected ? 'check-' : ''}square-o`}/>;
    }

    updateProduct(state) {
        this.setState(state, () => this.setProductCategories());
    }

    setProductCategories() {
        let productCategories = this.state.products
            .filter(x => x.condition === this.state.productCondition)
            .filter(x => x.size === this.state.productSize)
            .map(x => x.category)
            .filter((x, i, self) => self.indexOf(x) === i)
            .map(x => ({id: x, text: x}));

        if (productCategories.length) {
            this.setState({
                productCategoryId: productCategories[0].id,
                productCategories
            }, () => this.setFilteredProducts());
        }
    }

    updateProductCategory(state) {
        this.setState(state, () => this.setFilteredProducts());
    }

    setFilteredProducts() {
        let filteredProducts = this.state.products
            .filter(x => x.condition === this.state.productCondition)
            .filter(x => x.size === this.state.productSize)
            .filter(x => x.category === this.state.productCategoryId)
            .map(x => ({id: x.id, text: x.name}));

        this.setState({
            filteredProducts
        }, () => this.updateProductId(filteredProducts[0].id));
    }

    updateProductId(productId) {
        let product = this.state.products
            .find(x => x.id === parseInt(productId));

        this.setState({
            productId,
            productName: product.name,
            productBuyPrice: product.buyPrice,
            productSellPrice: product.sellPrice
        });
    }

    async signInOrCreateAdvert() {
        let userContext = UserContext.get();
        if (userContext) {
            let result = await this.createAdvert.call({
                dto: {
                    productId: this.state.productId,
                    address: this.state.address,
                    advertTypeId: this.state.advertTypeId,
                    costPerItem: this.state.costPerItem,
                    totalCount: this.state.totalCount,
                    repeatabilityTypeId: this.state.repeatabilityTypeId,
                    deliveryTypeId: this.state.deliveryTypeId,
                    taxTypeId: this.state.taxTypeId,
                    files: this.state.files,
                    isNetPalletDeal: this.state.isNetPalletDeal,
                    authorId: this.state.authorId,
                    fullName: this.state.fullName,
                    email: this.state.email,
                    phoneNumber: this.state.phoneNumber,
                    comment: this.state.comment
                }
            });

            if (result.success) {
                if (this.state.advertTypeId == 1) {
                    registerMetricaEvent('place_an_ad_sell');
                } else {
                    registerMetricaEvent('place_an_ad_buy');
                }
                if (this.state.isNetPalletDeal) {
                    if (this.state.advertTypeId == 1) {
                        registerMetricaEvent('new_provider');
                    } else {
                        registerMetricaEvent('new_client');
                    }
                }

                this.setState({showAdvertConfirmationModal: true});
            }
        }
        else {
            this.submitPhoneNumber();
            this.$wizard.pxWizard('goNext');
        }
    }

    async submitPhoneNumber() {
        if (this.state.isLoading)
            return;

        const phoneNumber = `7 ${this.state.phoneNumber}`;
        let result = await this.sendSecurityCode.call({
            dto: {
                phoneNumber
            }
        });
    }

    async submitCode() {
        if (this.state.isLoading)
            return;

        const {intent, onLogin, onHide} = this.props;
        const phoneNumber = `7 ${this.state.phoneNumber}`;

        let {response, json} = await this.signIn.extendedCall({
            dto: {
                phoneNumber,
                securityCode: this.state.code,
                intent
            }
        });

        UserContext.set(json.data);
        Token.set(response.headers.get('Bearer'));

        await this.signInOrCreateAdvert();
        this.setState({showAdvertConfirmationModal: true});
    }
}

export default withRouter(AdvertWizard);


// WEBPACK FOOTER //
// ./src/pages/Adverts/CreateAdvert/AdvertWizard.js